import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { useHistory } from "react-router-dom";
import { normalColumn, inputNumberColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P110List({ dataTable, setheadlerInpusText, dis }) {
    // const [globalFilter, setGlobalFilter] = useState(null);
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

   
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // header={header}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="weekNo" header="สัปดาห์ที่" body={(e) => normalColumn(e, "weekNo", "สัปดาห์ที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="weekPeriod" header="ระหว่างวันที่" body={(e) => normalColumn(e, "weekPeriod", "เลขที่สัญญา")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column
                        field="planWithdraw"
                        header="ปริมาณจำนวนเงินที่ขอเบิก"
                        body={(e) => inputNumberColumn(e, "planWithdraw", dataTable, setheadlerInpusText, "ปริมาณจำนวนเงินที่ขอเบิก", "ปริมาณจำนวนเงินที่ขอเบิก", "planWithdraw", dis, 9999999999, 2)}
                        style={{ textAlign: "center", width: "10%" }}
                        bodyStyle={bodyStyle.TXT_CENTER}
                    />
                    <Column
                        field="planProgress"
                        header="ประมาณ % ความก้าวหน้า"
                        body={(e) => inputNumberColumn(e, "planProgress", dataTable, setheadlerInpusText, "ปริมาณจำนวน % ความก้าวหน้า", "ปริมาณจำนวน%ความก้าวหน้า", "planProgress", false, 9999999999, 2)}
                        style={{ textAlign: "center", width: "10%" }}
                        bodyStyle={bodyStyle.TXT_CENTER}
                    />
                    <Column field="accruePlan" header="จำนวนเงินที่ขอเบิกสะสม" body={(e) => normalColumn(e, "accruePlan", "จำนวนเงินที่ขอเบิกสะสม")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="accrueProgress" header="%ความก้าวหน้าสะสม" body={(e) => normalColumn(e, "accrueProgress", "%ความก้าวหน้าสะสม")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="updateUserId" header="ผู้บันทึก" body={(e) => normalColumn(e, "updateUserId", "ผู้บันทึก")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="updateDt" header="วันที่-เวลา" body={(e) => normalColumn(e, "updateDt", "วันที่-เวลา")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
